// Function loadVideoBlock loads the VideoBlock class by dynamically importing the js on demand if needed

export function loadVideoBlock($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="VideoBlock"]');

	if(!$wg) {
		// console.info('VideoBlock: no widget found');
		return Promise.reject('VideoBlock widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-video-block-chunk" */ '../widgets/videoBlock').then(wg => {

		const { VideoBlock } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="VideoBlock"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new VideoBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new VideoBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the VideoBlock widget');

}
